import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { DateTypes } from '$/types/enums/DateTypes';

/**
 * Parse Date object to string without looking at the timezone
 * Method .toISOString() will shift our date by the timezone
 */
const dateToISOLikeString = (
  date: Date | null | string | undefined
): string => {
  if (typeof date === 'string') {
    date = parseISO(date);
  }

  if (!date) {
    throw new Error('Invalid date');
  }
  return format(date, DateTypes.YEAR_MONTH_DAY_DASH);
};

export default dateToISOLikeString;
